import { render, staticRenderFns } from "./SalesProductsPage.vue?vue&type=template&id=1597b872&scoped=true&"
import script from "./SalesProductsPage.vue?vue&type=script&lang=js&"
export * from "./SalesProductsPage.vue?vue&type=script&lang=js&"
import style0 from "./SalesProductsPage.vue?vue&type=style&index=0&id=1597b872&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1597b872",
  null
  
)

export default component.exports